<template>
  <div>
    <Head
      :title="seoTitle"
      :description="seoDescription"
      :keywords="seoKeywords"
    />

    <Container>
      <div class="container mx-auto py-8">
        <h1 class="font-bold text-4xl mb-8">
          Favorieten
        </h1>

        <div class="flex flex-col md:flex-row md:space-x-4">
          <div class="w-full shrink-0 md:w-[22%]">
            <ThemeAuctionCalendar
              :theme-auction-calendars="themeAuctionCalendar"
              class="hidden md:block"
            />
          </div>
          <div class="grow">
            <template v-if="auctions.meta.pagination.total === 0">
              <div class="text-center">
                <h2 class="font-bold text-xl md:text-3xl mb-4">
                  U heeft nog geen favoriete veilingen.
                </h2>
                <div class="text-lg md:text-xl">
                  Klik
                  <Link
                    class="text-sky-500 underline hover:no-underline"
                    :href="route('frontend.index')"
                  ><!--
                    -->hier<!--
                  --></Link>
                  om alle actieve veilingen te zien.
                </div>
              </div>
            </template>
            <template v-else>
              <div class="space-y-4">
                <ThemeAuctionBlock
                  v-for="auction in auctions.data"
                  :key="`${auction.slug}-${auction.auction_ends_at}`"
                  :auction="auction"
                  :theme-auction="auction.theme_auction"
                />
              </div>

              <div class="mt-8 mx-auto w-fit">
                <Pagination :pagination="auctions.meta.pagination" />
              </div>
            </template>
          </div>
        </div>

        <div class="mt-8">
          <ThemeAuctionCalendar
            :theme-auction-calendars="themeAuctionCalendar"
            class="block md:hidden"
          />
        </div>
      </div>
    </Container>
  </div>
</template>

<script>
import {Link} from '@inertiajs/vue2';
import Head from '../../Partials/Head.vue';
import Home from '../../Layouts/Home.vue';
import Container from '../../Partials/Container.vue';
import ThemeAuctionCalendar from '../ThemeAuctions/Partials/ThemeAuctionCalendar.vue';
import ThemeAuctionBlock from '../../Partials/New/ThemeAuctionBlock.vue';
import Pagination from '../../Partials/New/Pagination.vue';

export default {
  components: {
    Head,
    Link,
    Container,
    ThemeAuctionCalendar,
    ThemeAuctionBlock,
    Pagination,
  },

  layout: Home,

  props: {
    seoTitle: {
      required: true,
      type: String,
    },

    seoDescription: {
      required: true,
      type: String,
    },

    seoKeywords: {
      required: true,
      type: String,
    },

    auctions: {
      required: true,
      type: Object,
    },

    themeAuctionCalendar: {
      required: true,
      type: Array,
    },
  },
};
</script>
